import React, { createContext, useContext, ReactNode } from 'react';

interface PortalContextType {
  portalRoot: HTMLElement | null;
}

const defaultPortalContext: PortalContextType = {
  portalRoot: typeof document !== 'undefined' ? document.getElementById('root') : null,
};

export const PortalContext = createContext<PortalContextType>(defaultPortalContext);

interface PortalProviderProps {
  portalElement: HTMLElement | null;
  children: ReactNode;
}

export const PortalProvider: React.FC<PortalProviderProps> = ({ portalElement, children }) => {
  return <PortalContext.Provider value={{ portalRoot: portalElement }}>{children}</PortalContext.Provider>;
};

export const usePortalContext = (): PortalContextType => {
  return useContext(PortalContext);
};
